var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 48 48","fill":"none","stroke":"currentColor","stroke-width":"2"}},[_c('path',{attrs:{"d":"M8 6h14l2 4h16a2 2 0 012 2v26a2 2 0 01-2 2H8a2 2 0 01-2-2V8a2 2 0 012-2z"}}),_c('path',{attrs:{"d":"M18 26h12M24 20v12","stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }